import React, { useEffect } from 'react';

const AboutPage = () => {
  useEffect(() => {
    document.title = 'À propos - Xibaru Bambouck';
    
    return () => {
      document.title = 'Xibaru Bambouck';
    };
  }, []);

   return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <div className="bg-gradient-to-r from-blue-800 to-blue-800 text-white">
        <div className="container mx-auto px-4 py-16">
          <div className="text-center">
            <h1 className="text-4xl md:text-5xl font-bold mb-4">
              À propos de Xibaru Bambouck
            </h1>
            <p className="text-xl md:text-2xl text-blue-100 max-w-3xl mx-auto">
              Votre source d'informations fiable sur l'actualité locale et régionale
            </p>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 mb-16">
            {/* Mission Section */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                Notre Mission
              </h2>
              
              <div className="space-y-6 text-gray-700 leading-relaxed">
                <div>
                  <h3 className="text-xl font-semibold text-blue-600 mb-3">
                    La voix du Bambouck au-delà des frontières
                  </h3>
                  <p>
                    Face à l'absence d'un organe de presse capable de donner une visibilité 
                    internationale au département de Koungheul, Xibarubambouck.net a été créé 
                    pour combler ce vide.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-blue-600 mb-3">
                    L'information au service du développement
                  </h3>
                  <p>
                    Dans un monde marqué par la mondialisation et la globalisation, l'information 
                    joue un rôle clé dans le développement et la mise en lumière des initiatives 
                    locales. Notre mission est de rendre compte de l'actualité de Koungheul, de 
                    relayer les actions entreprises pour le bien-être des populations et d'assurer 
                    une communication fluide entre les habitants et la diaspora.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-blue-600 mb-3">
                    Connecter les communautés
                  </h3>
                  <p>
                    Grâce à notre plateforme numérique, nous donnons aux Koungheulois, où qu'ils 
                    soient, la possibilité de s'informer et de s'impliquer dans la vie de leur 
                    département.
                  </p>
                </div>
                
                <div>
                  <h3 className="text-xl font-semibold text-blue-600 mb-3">
                    Un média engagé
                  </h3>
                  <p>
                    Xibarubambouck.net, c'est aussi un média engagé dans la promotion de l'image 
                    réelle de Koungheul : mettre en avant les réussites et les initiatives positives, 
                    tout en exposant les défis et les problématiques pour favoriser un développement 
                    inclusif.
                  </p>
                </div>
                
                <div className="bg-blue-50 p-4 rounded-lg border-l-4 border-blue-800">
                  <p className="font-semibold text-blue-800">
                    Ensemble, faisons rayonner Koungheul et donnons une voix forte au Bambouck 
                    sur la scène nationale et internationale.
                  </p>
                </div>
                
                <p className="text-gray-600 italic">
                  Nous croyons en un journalisme de proximité qui met l'accent sur les 
                  préoccupations quotidiennes des citoyens, tout en maintenant les plus hauts 
                  standards d'intégrité et de professionnalisme.
                </p>
              </div>
            </div>
            
            {/* Values Section */}
            <div className="bg-white rounded-lg shadow-lg p-8">
              <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
                Nos Valeurs
              </h2>
              
              <div className="space-y-6">
                <div className="flex items-start group hover:bg-blue-50 p-4 rounded-lg transition-colors">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-4 mt-1 group-hover:bg-blue-700 transition-colors">
                    1
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg mb-2">Transparence</h3>
                    <p className="text-gray-600">
                      Nous nous engageons à être transparents dans notre travail journalistique 
                      et à fournir des informations vérifiées et fiables à nos lecteurs.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start group hover:bg-blue-50 p-4 rounded-lg transition-colors">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-4 mt-1 group-hover:bg-blue-700 transition-colors">
                    2
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg mb-2">Proximité</h3>
                    <p className="text-gray-600">
                      Nous privilégions les nouvelles qui touchent directement notre communauté 
                      et qui ont un impact concret sur la vie quotidienne des habitants.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start group hover:bg-blue-50 p-4 rounded-lg transition-colors">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-4 mt-1 group-hover:bg-blue-700 transition-colors">
                    3
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg mb-2">Intégrité</h3>
                    <p className="text-gray-600">
                      Nous respectons les principes éthiques du journalisme et nous nous 
                      engageons à traiter l'information avec objectivité et respect.
                    </p>
                  </div>
                </div>
                
                <div className="flex items-start group hover:bg-blue-50 p-4 rounded-lg transition-colors">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center text-sm font-bold mr-4 mt-1 group-hover:bg-blue-700 transition-colors">
                    4
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 text-lg mb-2">Innovation</h3>
                    <p className="text-gray-600">
                      Nous utilisons les nouvelles technologies pour améliorer notre couverture 
                      médiatique et offrir une expérience enrichissante à nos lecteurs.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center">
              Contactez-nous
            </h2>
            <div className="text-center text-gray-600 max-w-2xl mx-auto">
              <p className="mb-4">
                Vous avez une information à partager ? Une suggestion à nous faire ? 
                N'hésitez pas à nous contacter.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
                <a 
                  href="mailto:contact@xibarubambouck.com" 
                  className="bg-blue-800 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors"
                >
                  Nous contacter
                </a>
                <span className="text-gray-500">ou</span>
                <a 
                  href="tel:+221 77 436 93 94" 
                  className="border border-blue-600 text-blue-600 px-6 py-3 rounded-lg hover:bg-blue-50 transition-colors"
                >
                  Appelez-nous
                </a>
              </div>
            </div>
          </div>
          <div className="text-center text-gray-600 text-sm">
            © {new Date().getFullYear()} Xibaar Bambouck — Tous droits réservés.
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;
